import { getRateChanges } from '@/graphql/queries/shared/rate-change';

export default async ({ $apolloQuery, store }) => {
  await $apolloQuery(getRateChanges).then(results => {
    store.commit('search/set', { product: null });
    store.commit('rateChanges/set', results.changes);
    store.commit('utils/setPagination', results.meta.pagination);
  });
};
